/**
 * A coloured band's card classes, for a theme that draws its bands - every
 * section with a colour of its own, and the footer - as rounded cards in the
 * page column (`bandFrame: 'card'`).
 *
 * Every value reads a variable only such a theme sets (`themeVariables`), so in
 * every other theme these resolve to nothing and the band runs edge to edge as
 * it always has.
 */
export const BAND_CARD =
  'mx-auto w-full max-w-[var(--storefront-band-max,none)] sm:max-w-[var(--storefront-band-max-sm,none)] rounded-[var(--storefront-band-radius,0)] my-[var(--storefront-band-gap,0)] [overflow:var(--storefront-band-clip,visible)]';
